import React from 'react';
import { EditPanelCell, EditPanelCellLabel, EditPanelRow } from '../../../components/elements';
import { EditPanelTrueFalseUndefined } from '../../../components/utils/editPanel/EditPanelTrueFalseUndefined';

type YesNoEmpty = true | false | undefined;

export function EditPanelYesNoEmptyRow(props: {
    label: string;
    name: string;
    value: YesNoEmpty;
    onChange: (value: YesNoEmpty) => void;
    tooltip?: string | undefined;
}) {
    return (
        <EditPanelRow>
            <EditPanelCellLabel rowCount={4} text={props.label} tooltip={props.tooltip}></EditPanelCellLabel>
            <EditPanelCell rowCount={8}>
                <EditPanelTrueFalseUndefined
                    size="large"
                    undefinedText="Leeg"
                    name={props.name}
                    value={props.value}
                    onChange={(value) => props.onChange(value)}
                />
            </EditPanelCell>
        </EditPanelRow>
    );
}
